export const getMockData = (mockData, delay = 0, dispatch, type = {}) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (dispatch) {
        dispatch({ ...type, payload: mockData })
      }
      resolve(mockData)
    }, delay)
  })
}
